import React from 'react';

const ProductionIcon = ({ color }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2152 8.91331C11.0981 9.02664 11.0471 9.19095 11.0762 9.35193L11.913 14.15L7.59363 11.8953C7.45107 11.8186 7.2794 11.8222 7.13309 11.8953L2.82837 14.1756L3.63598 9.37011C3.66147 9.20936 3.61044 9.04857 3.49341 8.93529L0 5.54396L4.82008 4.82771C4.98082 4.80218 5.11964 4.70351 5.18907 4.55738L7.33047 0.183044L9.50129 4.54633C9.57428 4.69264 9.7131 4.79112 9.87385 4.81684L14.6977 5.50381L11.2152 8.91331Z" fill={color} />
    </svg>
  )
};

export default ProductionIcon;